import { environment } from '../../environments/environment';
import { ProjectComponent } from './project.component';
import { ProjectDetailComponent } from './project-detail.component';
import { pendingChangesGuard } from '../shared/core/pending-changes.guard';
import { roleGuard } from '../shared/core/role-guard.service';
import { ProjectListComponent } from './project-list/project-list.component';

export const routes = [
    {
        path: 'projectdetail',
        component: ProjectDetailComponent,
        canActivate: [roleGuard], data: { roles: [environment.clearanceRole] },
        canDeactivate: [pendingChangesGuard]
      },
      {
        path: 'projectdetail/:projectId',
        component: ProjectDetailComponent,
        canActivate: [roleGuard], data: { roles: [environment.clearanceRole] },
        canDeactivate: [pendingChangesGuard]
      },
      {
        path: 'projects',
        component: ProjectListComponent,
        canActivate: [roleGuard], data: { roles: [environment.clearanceRole] }
      },
];
